import { UIOrder } from "@flights/types";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../store";
import { useMemo } from "react";
import useCreateUrl from "./useCreateUrl";
import { SearchResultsURL, searchUtils } from "@flights/web-api-utils-universal";
type SearchURLs =
  | {
      home: string;
      searchresults: string;
    }
  | undefined;

const useSearchURL = (uiOrder?: UIOrder): SearchURLs => {
  let searchURLData: SearchResultsURL | undefined;
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const { createUrl } = useCreateUrl();
  if (uiOrder) {
    searchURLData = searchUtils.getSearchParams(uiOrder);
  } else {
    const { flightDetails, order, metaFlightDetails } = store;
    if (flightDetails && flightDetails.flight) {
      searchURLData = searchUtils.getSearchParams(flightDetails.flight);
    } else if (metaFlightDetails && metaFlightDetails.flight) {
      searchURLData = searchUtils.getSearchParams(metaFlightDetails.flight);
    } else if (order && order.order) {
      searchURLData = searchUtils.getSearchParams(order.order);
    }
  }

  const urls = useMemo(() => {
    if (searchURLData) {
      const { origin, destination, params: paramsValues } = searchURLData;

      const params = new URLSearchParams(paramsValues);
      const indexParams = new URLSearchParams(paramsValues);

      indexParams.set("origin", origin);
      indexParams.set("destination", destination);

      return {
        home: createUrl(`/?${indexParams}`),
        searchresults: createUrl(`/flights/${origin}-${destination}/?${params}`)
      };
    }

    return undefined;
  }, [searchURLData, createUrl]);
  return urls;
};

export default useSearchURL;
